import React from 'react';

const showCountryNotice = () => {
  let notice = '';
  if (window && window.lxl_current_lang && window.lxl_current_lang.locale) {
    const currentLang = window.lxl_current_lang.locale;
    if (currentLang === 'it_IT') {
      notice =
        '*Italia: prende come riferimento un campione di popolazione Italiana<sup>1</sup><br>&nbsp;Altre Nazioni: prende come riferimento un campione di popolazione proveniente da 6 diversi Paesi<sup>2</sup>';
    }
  }
  return <p dangerouslySetInnerHTML={{ __html: notice }} />;
};

export default showCountryNotice;
